var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.state.user.currentGroups.includes('Dirección'))?_c('AdminDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }